import React from 'react'
import { useTranslation } from 'react-i18next'
import { tagger } from '../util/util'
import '../css/notification.css'
import { useShowNotification } from '../hooks/useShowNotification'


export const Notification: React.FC = () => {
    const { t } = useTranslation('notification')
    const [isNotificationVisible, hideNotification] = useShowNotification()

    return (
        <div className={`news-notification ${isNotificationVisible && 'news-notification_visible'}`}>
            <img
                className="news-notification__close-button"
                src="https://static.persona.ly/images/notification/notification_close.svg"
                onClick={hideNotification}
            />

            <img
                className="news-notification__image"
                src="https://static.persona.ly/images/notification/Rummy-Circle-Logo.webp"
            />

            <div className="news-notification__content">
                <h3 className="news-notification__title">{tagger(t('title'), 'news-notification__nowrap')}</h3>
                <p className="news-notification__text">{tagger(t('text'), 'news-notification__link', '', true)}</p>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/notification.tsx